module.exports = __webpack_public_path__ + "de791a58.jpg";